var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9639 11.5C22.9639 5.14519 17.8268 0 11.482 0C5.13711 0 0 5.14519 0 11.5C0 17.2415 4.20155 21.9948 9.69588 22.8637V14.8222H6.7701V11.5H9.69588V8.96148C9.69588 6.08222 11.3969 4.49778 14.0165 4.49778C15.2753 4.49778 16.5851 4.71926 16.5851 4.71926V7.54741H15.1392C13.7103 7.54741 13.268 8.43333 13.268 9.3363V11.5H16.449L15.9387 14.8222H13.268V22.8637C18.7624 21.9948 22.9639 17.2415 22.9639 11.5Z",
    fill: "#612A71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9561 14.8222L16.4664 11.5H13.2684V9.33629C13.2684 8.43333 13.7107 7.5474 15.1396 7.5474H16.5855V4.71925C16.5855 4.71925 15.2757 4.49777 14.0169 4.49777C11.3973 4.49777 9.69628 6.08222 9.69628 8.96148V11.5H6.77051V14.8222H9.69628V22.8637C10.2746 22.9489 10.887 23 11.4824 23C12.0947 23 12.6901 22.9489 13.2684 22.8637V14.8222H15.9561Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFb);
export default __webpack_public_path__ + "static/media/share-fb.513beb7b1959856df47b8dbb66016b98.svg";
export { ForwardRef as ReactComponent };